import React from 'react';
import { IValueListCell } from './interfaces';
import { ValueCell } from '../ValueCell';

export const ValueListCell: React.FC<IValueListCell> = ({
  values,
}): JSX.Element => {
  if (!values) {
    return <ValueCell></ValueCell>;
  }

  return <span>{values.join(', ')}</span>;
};
